import { render, staticRenderFns } from "./Octo.vue?vue&type=template&id=1d9ad41f&scoped=true&"
import script from "./Octo.vue?vue&type=script&lang=ts&"
export * from "./Octo.vue?vue&type=script&lang=ts&"
import style0 from "./Octo.vue?vue&type=style&index=0&id=1d9ad41f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ad41f",
  null
  
)

export default component.exports